controllers.controller('WithdrawUnionpayController', [
    '$scope', '$state', '$stateParams', '$ionicLoading', '$ionicModal', 'LocaleService', 'API', 'ErrorService', 'constants',
    'Validator', 'Storage', 'Utils', 'UserService', 'CountryService',
    function ($scope, $state, $stateParams, $ionicLoading, $ionicModal, LocaleService, API, ErrorService, Const,
              Validator, Storage, Utils, UserService, CountryService) {

        LocaleService.wait().then(function (translation) {
            $scope.translation = translation;
        });

        $scope.validator = Validator.getPattern;
        $scope.user = UserService.get();
        $scope.constants = Const;
        $scope.countries = CountryService.get();
        $scope.modal = {actionText: LocaleService.translation.try_again, state: false};
        $scope.withdraw = {
            login: $stateParams.login,
            amount: $stateParams.amount
        };

        $scope.unionPayModel = {
            bankName: null,
            unionpayCardholderName: null,
            unionpayBankCardNumber: null,
            unionpayNationalIdCard: null,
            bankCountry: null,
            bankCity: null,
            bankBranch: null,
            bankCountryCode: null,
            bankCountryName: null
        };

        $scope.countriesModal = function (type, form) {
            $ionicModal.fromTemplateUrl('templates/countries-select.html', {
                scope: $scope,
                hardwareBackButtonClose: false,
                animation: 'slide-in-up'
            }).then(function (modal) {
                $scope.selectType = type;
                $scope.countriesList = $scope.countries;
                $scope.countryModal = modal;
                $scope.countryModal.show();
                $scope.FormController = form;
            });
        };

        $scope.setCountry = function (country) {
            if ($scope.selectType === 'country') {
                $scope.unionPayModel.bankCountryName = country.country;
                $scope.unionPayModel.bankCountryCode = country.code;
                $scope.FormController.bankCountry.$setDirty();
            }
            $scope.search = {};
            $scope.countryModal.hide();
        };

        $scope.closeCountryModal = function () {
            $scope.countryModal && $scope.countryModal.hide();
            $scope.countriesList = null;
        };

        $scope.submit = function (form) {
            Utils.formRevalidate(form);
            if (!form.$valid) return;

            var request = {
                login: parseInt($scope.withdraw.login, 10),
                amount: parseInt($scope.withdraw.amount, 10),
                bankName: $scope.unionPayModel.bankName,
                unionpayCardholderName: $scope.unionPayModel.unionpayCardholderName,
                unionpayBankCardNumber: $scope.unionPayModel.unionpayBankCardNumber,
                unionpayNationalIdCard: $scope.unionPayModel.unionpayNationalIdCard,
                bankCountry: $scope.unionPayModel.bankCountryCode,
                bankCity: $scope.unionPayModel.bankCity,
                bankBranch: $scope.unionPayModel.bankBranch
            };
            $ionicLoading.show();
            return API.withdrawalUnionPay(request)
                .then(checkResponse)
                .then(function (response) {

                    $ionicLoading.hide();

                    if (Const.withdrawalComplianceRequired && $scope.user.complianceStatus !== 'approved') {
                        return $state.go('root.app.withdrawCompliance');
                    }

                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawSuccess;
                    $scope.modal.isError = false;
                    $scope.modal.textContent = '';
                    $scope.modal.actionText = LocaleService.translation.continueTrading;
                    $scope.modal.back = 'root.app.menu';
                    $scope.modal.state = true;
                })
                .catch(function (error) {
                    $ionicLoading.hide();
                    $scope.modal.textTitle = LocaleService.translation.messages.withdrawalFailed;
                    $scope.modal.actionText = LocaleService.translation.tryAgain;
                    $scope.modal.isError = true;
                    $scope.modal.textContent = LocaleService.translation.messages[error.code] || '';
                    $scope.modal.state = true;
                });
        };

        function checkResponse(data) {
            if (data.status !== 1) {
                throw new ErrorService({
                    source: 'WithdrawUnionpayController',
                    type: Const.error.type.VALIDATION,
                    code: data.code,
                    severity: 'warning',
                    data: {response: data}
                });
            }
            return data;
        }

        $scope.$on('$ionicView.afterLeave', function (event) {
            $scope.countryModal && $scope.countryModal.hide() && $scope.countryModal.remove();
        });
    }]);
